<template>
  <div>
    <top-bar :heading="'Training Plan: ' + user.name_full" :buttons="buttons"></top-bar>
    <div class="container-fluid mt-3">
      <div class="p-3" v-if="!loaded">
        <!-- Loading State -->
        <div class="text-center" style="margin: 50px;">
          <loading-spinner :loading="true"></loading-spinner>
        </div>

      </div>
      <div class="p-3" v-if="loaded">

        <div class="row" v-show="!streams.length">
          <div class="col-md-12 text-center" style="margin: 50px 0;">
            <loading-spinner :loading="true"></loading-spinner>
          </div>
        </div>

        <div class="row" v-show="streams.length">
          <div class="col-12">
            <h3>STUDENT STREAM</h3>
            <h4>One specialist stream must be selected</h4>
          </div>

          <div class="col-3" v-for="stream in streams" v-show="stream.id !== 1" :key="stream.id">
            <div class="card pointer" @click="setUserStream([stream.id])">
              <div class="card--feature card--feature__grey card--feature__full" :class="stream.selected ? 'card--feature__orange' : 'card--feature__grey'">
                <div class="card--feature-text font150">
                  {{ stream.stream }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="userStream.courses.length">
          <div class="col-12">
            <h3>STUDENT CORE UNITS</h3>
            <h5>Please review and set start and finish dates for {{ user.name }}'s Core Units.</h5>
          </div>

          <div class="col-12 mb-4">
            <div class="row" style="justify-content: space-around;">
              <div class="col">
                <div class="dot dot__big dot__bottom dot-orange"></div>&nbsp;&nbsp;
                ENROLLED
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-blue"></div>&nbsp;&nbsp;
                ENABLED
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-lime"></div>&nbsp;&nbsp;
                COMPLETE
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-gold"></div>&nbsp;&nbsp;
                RPL
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-teal"></div>&nbsp;&nbsp;
                CT
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-yellow"></div>&nbsp;&nbsp;
                CM
              </div>
              <div class="col">
                <div class="dot dot__big dot__bottom dot-platinum"></div>&nbsp;&nbsp;
                NOT ENROLLED
              </div>
            </div>
          </div>
        </div>

        <stream-units title="UNITS" v-model="userStream.courses" :loading="loading" @submit="saveCourses"></stream-units>
      </div>
      <div class="row" v-show="!userStream.courses.length">
        <div class="col-md-12 text-center" style="margin: 50px 0;">
          <loading-spinner :loading="true"></loading-spinner>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import StreamUnits from '../../components/TrainingPlan/StreamUnits'

export default {
  name: 'TrainingPlan',
  components: { StreamUnits },
  data () {
    return {
      streams: [],
      loading: false,
      loaded: false,
      user: {
        loaded: false,
        streams: []
      },
      userStream: {
        courses: []
      },
      buttons: [
        { label: 'Edit User', 'url': '/users/' + this.id },
        //{label: 'Training Plan', 'url': '/users/' + this.id + '/training_plan' },
        { label: 'Progression', url: '/users/' + this.id + '/progression' },
        { label: 'Results', url: '/users/' + this.id + '/results' }
      ]
    }
  },
  methods: {
    loadStreams () {
      this.loaded = false
      this.axios.get('course_streams', { params: { order_by: 'updated_at,desc' } }).then((rsp) => {
        this.streams = rsp.data.filter(stream => stream.published).map(stream => {
          stream.selected = false
          return stream
        })
        this.getUser()
      }).catch((err) => this.$snotify.error(err.response.data.message))
    },
    setUserStream (streams) {
      this.axios.post('/users/' + this.id + '/training_plan', { streams: JSON.stringify(streams) }).then(() => {
        this.$snotify.success('User Stream Updated')
        this.loadStreams()
      })
    },
    getUser () {
      this.axios.get('/users/' + this.id, { params: { includes: 'streams,streams.courses' } }).then(rsp => {
        rsp.data.data.dob = new Date(rsp.data.dob)
        rsp.data.data.loaded = true
        this.user = rsp.data.data

        const streamIds = this.user.streams.map(x => x.id)

        this.streams.map(stream => {
          stream.selected = streamIds.includes(stream.id)
        })
        // set selected stream in streams array for display purposes
        this.getUserResults()

      }).catch(err => this.$errorOut(err))
    },
    getUserResults () {
      this.user.loaded = false
      this.axios.get('/user_courses/' + this.id + '/streams').then(rsp => {
        let streams = rsp.data.map(stream => {
          if (!stream.courses) stream.courses = []

          stream.courses = stream.courses.map(course => {
            return this.parseCourse(course)
          })

          return stream
        })

        this.assignUserCoursesToStreams(streams)
        this.user.streams = streams
        this.user.loaded = true
      })
    },
    parseCourse (course) {
      if (course.is_core) course.is_enrolled = true
      course.changed = false

      return course
    },
    assignUserCoursesToStreams (streams) {
      if(streams.filter(stream => stream.is_enabled).length) {
        this.userStream = streams.filter(stream => stream.is_enabled)[0]
      }


      this.loading = false
      this.loaded = true
    },
    saveCourses () {
      this.loading = true

      const user_courses = this.userStream.courses.map((user_course, index) => {
        return {
          id: user_course.id,
          user_id: user_course.user_id,
          course_id: user_course.course_id,
          ordinal: index + 1,
          has_credit_transfer: user_course.has_credit_transfer,
          is_complete_manual: user_course.is_complete_manual,
          is_enabled: user_course.is_enabled,
          has_rpl: user_course.has_rpl,
          is_enrolled: user_course.is_enrolled,
          due_notes: user_course.due_notes,
          competent_at: user_course.competent_at,
          ct_rpl_date: user_course.ct_rpl_date,
          commenced_at: user_course.commenced_at
        }
      })

      this.axios.post('/users/' + this.id + '/training_plan', { user_courses }).then(() => {
        this.$snotify.success('Training Plan Saved')
        this.loadStreams()
      }).catch(err => {
        this.$snotify.error(err.response.data.message)
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadStreams()
  },
  metaInfo: {
    title: 'Training Plan'
  },
  props: ['id']
}
</script>
